export class Booking {
    id: string;
    uid: string;
    title: string;
    description: string;
    addressId: string;
    cancelled: boolean;
    ended: boolean;
    endedDate: Date;
    confirmed: boolean;
    jobStared: boolean;
    staringDate: Date;
    providerId: string;
    imageUrl0: string;
    imageUrl1: string;
    imageUrl2: string;
    imageUrl3: string;
    imageUrl4: string;
    imageUrl5: string;
    signatureUrl: string;
    statusNote: string;
    constructor() {
        this.id = '';
        this.uid = '';
        this.title = '';
        this.addressId = '';
        this.description = '';
        this.staringDate = new Date();
        this.cancelled = false;
        this.ended = false;
        this.endedDate = new Date();
        this.confirmed = false;
        this.jobStared = false;
        this.providerId = '';
        this.imageUrl1 = '';
        this.imageUrl0 = '';
        this.imageUrl2 = '';
        this.imageUrl3 = '';
        this.imageUrl4 = '';
        this.imageUrl5 = '';
        this.signatureUrl = '';
        this.statusNote = '';
    }
}
